import React from "react";

// sample_info は 133 / 137 / 135 / 136 をまとめた複合カードです。
// 呼び出し元では panel 解決だけを行い、描画本体はこの renderer に寄せます。
export function renderSampleSectionBody({
    section,
    basePanel,
    commentPanel,
    detailPanel,
    sampleTotalType,
    renderContents,
    renderTotalGrid,
    sectionGridRowStyle,
    isEmpty
}) {
    return (
        <div>
            {!isEmpty(basePanel) ? (
                <div style={{ marginBottom: 8 }}>
                    {renderContents({ panel: basePanel })}
                </div>
            ) : null}
            {!isEmpty(commentPanel) ? (
                <div style={{ marginBottom: 8 }}>
                    {renderContents({ panel: commentPanel })}
                </div>
            ) : null}
            {!isEmpty(detailPanel) ? (
                <div style={{ marginBottom: 8 }}>
                    {renderContents({
                        panel: detailPanel,
                        getRowStyle: sectionGridRowStyle(section.id, detailPanel),
                        hideRowNumbers: false,
                        rowDrag: false
                    })}
                </div>
            ) : null}
            {!isEmpty(detailPanel) && !isEmpty(sampleTotalType) ? (
                renderTotalGrid({ ...section, totalType: sampleTotalType }, detailPanel, sampleTotalType, false, true)
            ) : null}
        </div>
    );
}
